{
  "Dashboard": "仪表盘",
  "BlyCareShippingProte": "BlyCare 运输保障",
  "LoadingBlyCare": "正在加载 BlyCare…",
  "LoadingWidgetSetting": "正在加载小部件设置…",
  "PreparingYourWorkspa": "正在准备您的工作区",
  "Language": "语言",
  "English": "English",
  "EnglishDefault": "English（默认）",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "设置指南",
  "CompletedOfTotalComp": "已完成 {{completed}}/{{total}}",
  "Dismiss": "关闭",
  "MoreActions": "更多操作",
  "ToggleSetupGuide": "切换设置指南",
  "ActivateAppEmbed": "启用应用嵌入",
  "ClickTheEnableButton": "1. 点击下方的“启用”按钮，打开您的 Shopify 主题编辑器。",
  "BlyCareEmbedSection": "2. 在左侧“应用嵌入”区域找到 BlyCare。确保其开关已开启，然后点击右上角的“保存”。",
  "Enable": "启用",
  "PublishWidget": "发布小部件",
  "PublishStorefront": "在店铺前台发布小部件，供顾客购买。",
  "Publish": "发布",
  "SetProtectionFee": "设置保障费",
  "FeeYouWantToCharge": "设置您想向顾客收取的费用。",
  "Setup": "设置",
  "TestYourWidgetOnYour": "在您的店铺中测试小部件",
  "AddAProductToYourCar": "将商品加入购物车，确认出现运输保障小部件。选择运输保障，然后继续结算，并确认结算页面中包含运输保障商品。",
  "TestNow": "立即测试",
  "Working": "一切正常",
  "NeedHelp": "需要帮助",
  "MarkAsCompleted": "标记为已完成",
  "AppStatus": "应用状态",
  "AppEmbed": "应用嵌入",
  "EnableAppEmbedToDisp": "启用应用嵌入以在购物车中显示运输保障。",
  "CartPage": "在购物车页面显示运输保障。",
  "CheckoutBlock": "结算区块",
  "CheckoutPage": "在结算页面显示运输保障。",
  "Active": "已启用",
  "Inactive": "未启用",
  "Analytics": "分析",
  "Today": "今天",
  "Last7Days": "最近 7 天",
  "Last30Days": "最近 30 天",
  "Last60Days": "最近 60 天",
  "Last90Days": "最近 90 天",
  "Last365Days": "最近 365 天",
  "Custom": "自定义",
  "Start": "开始",
  "End": "结束",
  "DateRange": "日期范围",
  "SelectedRange": "已选范围：{{range}}",
  "Cancel": "取消",
  "Save": "保存",
  "ChooseAStartDateOnOr": "请选择不晚于结束日期的开始日期，且不要选择今天之后的日期。",
  "PreviousMonth": "上个月",
  "NextMonth": "下个月",
  "ProtectionRevenue": "保障收入",
  "ProtectedOrders": "已保障订单",
  "ProtectedOrderRate": "订单保障率",
  "LoadingAnalytics": "正在加载分析数据…",
  "AnalyticsCouldNotLo": "无法加载分析数据",
  "RetryAnalytics": "重试分析",
  "Resources": "资源",
  "HowDoesShippingProte": "运输保障如何运作？",
  "BlyCareAddsAShipping": "BlyCare 会向您的购物车添加运输保障小部件。顾客可选择为订单添加保障。由商家收取保障费、决定承保范围，并使用这些费用处理索赔。",
  "DoesBlyCareCoverInsu": "BlyCare 是否承保保险索赔？",
  "NoBlyCareIsNotInsura": "否。BlyCare 不是保险，也不支付索赔。BlyCare 仅为商家提供小部件和工具，以便管理自己的运输保障计划。",
  "EmailUs": "发送邮件给我们",
  "LiveChat": "在线聊天",
  "HelpCenter": "帮助中心",
  "Settings": "设置",
  "CheckoutWidget": "结算小部件",
  "CartWidget": "购物车小部件",
  "PriceSetting": "价格设置",
  "ProductSetting": "商品设置",
  "AdminLanguage": "管理后台语言",
  "AdminLanguageTitle": "管理后台语言",
  "AdminLanguageHelp": "仅更改您自己的应用语言，不影响顾客。",
  "AppLanguage": "应用语言",
  "UnableToLoadSettings": "无法加载设置",
  "TryAgain": "重试",
  "Discard": "放弃",
  "LoadingSettings": "正在加载设置",
  "PageNotFound": "页面未找到",
  "ProductSettingsCould": "无法保存商品设置。",
  "Fulfillment": "履约",
  "FulfillmentHelp": "选择保障商品何时标记为已履约。",
  "ManuallyFulfill": "手动履约",
  "MarkFulfilledWhenFir": "订单中第一件商品履约后标记为已履约",
  "MarkFulfilledWhenAll": "订单中所有其他商品履约后标记为已履约",
  "MarkFulfilledImmedi": "订单创建后立即标记为已履约",
  "Exclusions": "排除",
  "ExclusionsHelp": "选择不适用保障的情况。",
  "ExclusionType": "排除类型",
  "Select": "选择",
  "SelectedExclusions": "已选排除项",
  "RemoveName": "移除 {{name}}",
  "WhenExcluded": "排除时",
  "HideWidget": "隐藏小部件",
  "KeepWidgetButSkipThe": "保留小部件但跳过费用",
  "ExcludeProductType": "排除商品类型",
  "SearchProductType": "搜索商品类型",
  "ExcludeSKU": "排除 SKU",
  "SearchSKU": "搜索 SKU",
  "ExcludeCollection": "排除商品系列",
  "SearchCollection": "搜索商品系列",
  "ExcludeMarket": "排除市场",
  "SearchMarket": "搜索市场",
  "ExcludeLanguage": "排除语言",
  "SearchLanguage": "搜索语言",
  "Add": "添加",
  "PriceSettingsCouldNo": "无法保存价格设置。",
  "ShippingProtectionPr": "运输保障价格",
  "SetHowMuchPriceDoYou": "设置向顾客收取的金额",
  "PricingMethod": "定价方式",
  "Fixed": "固定",
  "Percentage": "百分比",
  "UniversalProtectionP": "通用保障价格",
  "PercentageOfCartSubt": "购物车小计百分比",
  "EditCappedPrice": "编辑封顶价格",
  "ShippingProtectionFe": "按百分比计算的运输保障费，起价为 {{minPrice}} USD，每档递增 {{increment}} USD，封顶为 {{capped}} USD。",
  "MinProtectionFee": "最低保障费",
  "IncrementAmount": "递增金额",
  "CappedProtectionFee": "封顶保障费",
  "AddTierPrice": "添加阶梯价格",
  "AddTier": "添加阶梯",
  "TierPriceHelp": "如果购物车金额与任何阶梯购物车价格范围都不匹配，将适用您在上一页设置的通用价格。",
  "MinCartPrice": "最低购物车金额",
  "MaxCartPrice": "最高购物车金额",
  "ProtectionFee": "保障费",
  "RemoveTier": "移除阶梯",
  "Required": "必填",
  "ThisFieldIsRequired": "此字段为必填项。",
  "MustBeGreaterThanZero": "{{label}} 必须大于 0。",
  "MustBeOrLess": "{{label}} 必须小于或等于 {{max}}。",
  "AtMostTwoDecimals": "{{label}} 最多可保留 2 位小数。",
  "MustBeLargerThanMinC": "必须大于最低购物车金额",
  "MustBeLargerThanMaxC": "必须大于最高购物车金额",
  "MustBeSmallerThanMin": "必须小于最低购物车金额",
  "Price": "价格",
  "MinimumPrice": "最低价格",
  "Increment": "递增",
  "CartPageWidget": "购物车页面小部件",
  "CheckoutPageWidget": "结算页面小部件",
  "WidgetFormat": "小部件格式",
  "TickerWidget": "普通小部件",
  "CheckoutButtonWidget": "结算按钮小部件",
  "Text": "文本",
  "MainText": "主文本",
  "Title": "标题",
  "Description": "描述",
  "MainButtonText": "主按钮文本",
  "SecondaryButtonText": "次要按钮文本",
  "EnabledDescription": "启用时的描述",
  "DisabledDescription": "禁用时的描述",
  "PleaseEnterTitle": "请输入标题",
  "PleaseEnterDescript": "请输入描述",
  "PleaseEnterMainButt": "请输入主按钮文本",
  "PleaseEnterSecondar": "请输入次要按钮文本",
  "PleaseEnterEnabledD": "请输入启用时的描述",
  "PleaseEnterDisabled": "请输入禁用时的描述",
  "EGViewTerms": "例如：查看条款",
  "EGHttpTerms": "例如：https://terms.com",
  "Footer": "页脚",
  "FooterText": "页脚文本",
  "FooterLink": "页脚链接",
  "TooltipLink": "提示框链接",
  "FooterVisibility": "页脚可见性",
  "TitleInfoVisibility": "标题信息可见性",
  "Disabled": "禁用",
  "Enabled": "启用",
  "Color": "颜色",
  "ColorStyle": "颜色样式",
  "SizeAndDisplay": "尺寸与显示",
  "IconSize": "图标尺寸",
  "IconRadius": "图标圆角",
  "BorderSize": "边框粗细",
  "BorderRadius": "边框圆角",
  "HorizontalPadding": "水平内边距",
  "VerticalPadding": "垂直内边距",
  "ToggleFormat": "切换格式",
  "Switch": "开关",
  "Checkbox": "复选框",
  "Border": "边框",
  "Background": "背景",
  "ProtectionDescript": "保障描述",
  "MainButtonBackgrou": "主按钮背景",
  "EnabledToggle": "启用状态的开关",
  "DisabledToggle": "禁用状态的开关",
  "Automatic": "自动",
  "Neutral": "中性",
  "Info": "信息",
  "Success": "成功",
  "Warning": "警告",
  "Critical": "严重",
  "Subdued": "柔和",
  "Transparent": "透明",
  "ThemeColor": "主题色",
  "ResetToDefaultColor": "{{label}}：重置为默认颜色",
  "OpenColorPicker": "{{label}}：打开颜色选择器",
  "Icon": "图标",
  "PackageIcon": "包裹图标",
  "PackageIconNumber": "包裹图标 {{value}}",
  "UploadIcon": "上传图标",
  "NoIcon": "无图标",
  "AcceptedFormats": "支持的格式：PNG、JPG、SVG",
  "MaximumFileSize": "最大文件大小：50 MB",
  "AddFiles": "添加文件",
  "RemoveImage": "移除图片",
  "Uploading": "正在上传",
  "UploadFailedTryAgain": "上传失败，请重试。",
  "ChooseAJPEGPNG": "请选择不超过 50 MB 的 JPEG、PNG 或 SVG 图片。",
  "ChooseNonemptyImage": "请选择非空且不超过 50 MB 的 JPEG、JPG、PNG 或 SVG 图片。",
  "ImageCouldNotBeRead": "无法读取该图片。",
  "FileContentsMismatch": "文件内容必须与其 JPEG、PNG 或 SVG 图片类型一致。",
  "ImageCouldNotBeDecode": "无法解码该图片。",
  "InvalidImageUrl": "上传服务返回了无效的图片 URL。",
  "MissingPublicImageUrl": "上传服务未返回公开的图片 URL。",
  "CustomCssTooLong": "自定义 CSS 最多可包含 2,000 个字符。",
  "ChooseValidIconUrl": "请选择具有有效 URL 的上传图标。",
  "EnterNumberRange": "请输入 {{min}} 到 {{max}} 之间的数字。",
  "EnterLocaleTextRange": "请输入 {{locale}} 文本，长度在 1 到 {{limit}} 个字符之间。",
  "EnterValidLearnMoreUrl": "请输入以 https:// 或 http:// 开头的有效“了解更多”URL。",
  "ReviewHighlightedFields": "请检查突出显示的字段。",
  "CannotChangePublishState": "表单通过验证前无法更改发布状态：{{reason}}",
  "BlyCareCouldNotSave": "BlyCare 无法保存。",
  "CheckoutRequiresPlus": "自定义结算页面需要 Shopify Plus。",
  "SaveSucceededReloadFailed": "保存请求已成功，但无法加载最新的小部件设置。请刷新以确认您的更改。",
  "BlyCareCouldNotComplete": "BlyCare 无法完成此请求。",
  "ShopifyAuthorizationRequired": "需要 Shopify 授权。",
  "AppBridgeUnavailable": "Shopify App Bridge 不可用",
  "ExtensionStatusUnavailable": "Shopify 扩展状态不可用。",
  "ConfigurationPreview": "配置预览",
  "On": "开",
  "Off": "关",
  "Unpublish": "取消发布",
  "AppEmbedIsNotEnable": "应用嵌入未启用。",
  "GoEnabled": "前往启用",
  "ViewOnYourStorefront": "在店铺前台查看",
  "PreviewProtection": "预览保障",
  "MoreInformation": "更多信息",
  "Cart": "购物车",
  "Subtotal": "小计",
  "Checkout": "结算",
  "DiscountCode": "折扣码",
  "Apply": "应用",
  "Shipping": "运费",
  "Total": "总计",
  "ShippingProtection": "运输保障",
  "Product": "商品",
  "CopyLink": "复制链接"
}
